//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Table from "@/components/FilterTable/Table.vue";
import BackendServices from "@/services/backend-services.js";

const ALL_INSIGNIA_OPTION = { id: null, name: "Todas" };

export default {
  name: "AutomaticPrices",
  components: {
    Table,
  },
  data: function () {
    return {
      allInsigniaOption: ALL_INSIGNIA_OPTION,
      rightSidePane: false,
      insigniaList: [],
      selectedInsignia: null,
      selectedPrice: "avg",
      configData: {},
      priceList: [
        {
          id: "min",
          name: "Preço Mínimo",
        },
        {
          id: "avg",
          name: "Preço Médio",
        },
        {
          id: "max",
          name: "Preço Máximo",
        },
      ],
      selectedTime: -1,
      timeList: [
        {
          days: -1,
          name: "YTD (ao fecho do mês anterior)",
        },
        {
          days: 730,
          name: "24 meses",
        },
        {
          days: 365,
          name: "12 meses",
        },
        {
          days: 180,
          name: "6 meses",
        },
        {
          days: 90,
          name: "3 meses",
        },
        {
          days: 30,
          name: "1 mês",
        },
        {
          days: 15,
          name: "15 dias",
        },
        {
          days: 7,
          name: "7 dias",
        },
      ],
      parametersCategoryList: [{ id: null, name: "Todas" }],
      parametersSelectedCategory: null,
      selectPeriod: false,
      selectionColumns: [
        {
          name: "insignia",
          label: "Insignia",
          align: "left",
          sortable: false,
          field: (row) =>
            row.insignia_id === null
              ? ALL_INSIGNIA_OPTION.name
              : this.insigniaList.filter((i) => i.id === row.insignia_id).pop()
                  .name,
        },
        {
          name: "category",
          label: "Categoria",
          align: "left",
          sortable: false,
          field: (row) =>
            this.parametersCategoryList
              .filter((i) => i.id === row.category)
              .pop().name,
        },
        {
          name: "price",
          label: "Preço",
          align: "left",
          sortable: false,
          field: (row) =>
            this.priceList.filter((i) => i.id === row.price_operation).pop()
              .name,
        },
        {
          name: "period",
          label: "Período",
          align: "left",
          sortable: false,
          field: (row) =>
            this.timeList.filter((i) => i.days === row.period).pop().name,
        },
        {
          name: "rtlOrder",
          label: "Ordenação RTL",
          align: "left",
          sortable: false,
          // FIXME: Add the icon with the order.
          field: () => "ESPETAR BONEQUINHO",
        },
      ],
      parametersOrderColumns: [
        {
          name: "order",
          label: "Ordenação",
          align: "left",
          sortable: false,
          field: (row) => row.name,
        },
      ],
      parametersOrderList: [],
      defaultSelectedCategory: null,

      price: "0,00",
      defaultOrderColumns: [
        {
          name: "category",
          label: "Categoria",
          align: "left",
          sortable: false,
          field: (row) =>
            this.parametersCategoryList
              .filter((i) => i.id === row.category_id)
              .pop().name,
        },
        {
          name: "price",
          label: "Preço",
          align: "left",
          sortable: false,
          field: (row) => `${row.price} €`,
        },
      ],
      defaultOrderList: [],
    };
  },
  created: function () {
    this.getInsignias();
    this.getCategories();
    this.getOrderList();
    this.getConfigData();
  },
  mounted: function () {},
  methods: {
    getInsignias: async function () {
      const response = await BackendServices.getAllHierarchiesById(6);

      this.insigniaList.splice(0, this.insigniaList.length, ...response.data);
    },
    getCategories: async function () {
      const response = await BackendServices.getAllHierarchiesById(2);
      this.parametersCategoryList.splice(
        1,
        this.parametersCategoryList.length,
        ...response.data
      );
    },
    getOrderList: function () {
      this.isLoading = true;
      BackendServices.getAllHierarchiesById(6).then((response) => {
        this.parametersOrderList = response.data;
        this.isLoading = false;
      });
    },
    getConfigData: function () {
      this.isLoading = true;
      BackendServices.getConfig("auto_pricing").then((response) => {
        this.configData = response.data;
        this.isLoading = false;
      });
    },
    addConfigLine: function () {
      this.configData.rtl_config.push({
        insignia_id: this.selectedInsignia,
        price_operation: this.selectedPrice,
        category_id: this.parametersSelectedCategory,
        period: this.selectedTime,
        use_custom_period: this.selectPeriod,
      });
    },
    addDefaultPriceLine: function () {
      this.configData.default_price_config.push({
        category_id: this.defaultSelectedCategory,
        price: this.price,
      });
    },
    saveConfig: function () {
      this.isLoading = true;
      BackendServices.saveConfig("auto_pricing", this.configData).then(() => {
        this.isLoading = false;
        window.location.reload();
      });
    },
  },
  computed: {
    selectionList: function () {
      return this.configData.rtl_config;
    },
    priceConfigList: function () {
      return this.configData.default_price_config;
    },
  },
};
